// extracted by mini-css-extract-plugin
export default {"bulk-actions":"ProductActionsButton_bulk-actions__jfroo"};